const isExternalUrl = (url) => {
  const host = window.location.hostname;

  const linkHost = ((urlString) => {
    if (/^https?:\/\//.test(urlString)) {
      const parser = document.createElement('a');
      parser.href = urlString;

      return parser.hostname;
    }

    return window.location.hostname;
  })(url);

  return host !== linkHost;
};

export default isExternalUrl;
